import { memo, useEffect } from 'react'

import { IMobileProps } from '../types'
import { BackButton, SlideUp } from 'common-components'

import * as Styled from './styled'
import { useMobileInnerSliderCallbacks } from 'hooks/useMobileInnerSliderCallbacks'

const TtsMobileDrawer: React.FC<IMobileProps> = (props: IMobileProps) => {
  const { content, onClose, isOpen } = props

  const { openCallback, closeCallback } = useMobileInnerSliderCallbacks()
  useEffect(() => {
    if (isOpen) {
      openCallback()
    }
    return () => {
      closeCallback()
    }
  }, [isOpen, openCallback, closeCallback])

  return (
    <SlideUp isOpen={isOpen} onClose={onClose}>
      <Styled.MobileFlyoutContent>
        <BackButton onClick={onClose} />
        {content}
      </Styled.MobileFlyoutContent>
    </SlideUp>
  )
}

export default memo(TtsMobileDrawer)
